// base=/etc/designs/portal/clientlibs

// -----------------------------------------------------------------------------
// VENDOR CODE
// -----------------------------------------------------------------------------
//
// Don't forget to add vendor libs to wiki page:
//
// See https://wiki.swisscom.com/display/PD/PORTAL+-+3rd+Party+Javascript+and+CSS+Libraries
// -----------------------------------------------------------------------------

// jQuery plugins
import 'etc/designs/portal/clientlibs/desktop/js/vendor/jquery/jquery.tmpl.min.js';

// jQuery extensions
import 'etc/designs/base/clientlibs/shared/vendor/jquery.cookies.2.2.0.min.js';
import 'etc/designs/portal/clientlibs/desktop/js/vendor/jquery.tablesorter.js';
import 'etc/designs/portal/clientlibs/desktop/js/vendor/jquery.transit.min.js';

// Other
import 'etc/designs/portal/clientlibs/desktop/js/vendor/jwplayer.js';

// -----------------------------------------------------------------------------
// SWISSCOM CODE used by both o2012 (res) and old (corporate) pages
// -----------------------------------------------------------------------------
// # Global defaults for dialog
import 'etc/designs/portal/clientlibs/desktop/js/dialog.js';

// Seems to be used directly
import 'etc/designs/portal/clientlibs/desktop/js/mediaplayer.js';
import 'etc/designs/portal/clientlibs/desktop/js/videoteasercomp.js';

// Used by forms
import 'etc/designs/portal/clientlibs/desktop/js/tracking.js';

// -----------------------------------------------------------------------------
// SWISSCOM CODE / LIBRARIES
// -----------------------------------------------------------------------------
import 'etc/designs/base/clientlibs/shared/libraries/SCS.Url.js';
import 'etc/designs/portal/clientlibs/desktop/js/common.js';

// COMPONENTS
import 'etc/designs/portal/clientlibs/desktop/js/scCarousel.js';
import 'etc/designs/portal/clientlibs/desktop/js/contactwizard.js';
import 'etc/designs/portal/clientlibs/desktop/js/expertchat.js';
import 'etc/designs/portal/clientlibs/desktop/js/lightbox.js';
import 'etc/designs/portal/clientlibs/desktop/js/supportstrip.js';
import 'etc/designs/portal/clientlibs/desktop/js/fullbleed.js';

// BOOTSTRAPPERS
import 'bootstrap/sdx-modal';
import 'bootstrap/smooth-scroll';
import 'bootstrap/textcutter';

// -----------------------------------------------------------------------------
// TERRIFIC MODULES - A-Z PLEASE
// -----------------------------------------------------------------------------
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Accordion.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Accordion.SingleMode.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Accordion.FullBleed.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.BackgroundContainer.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.BrightcoveOverlay.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.ContactCollapsable.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.CallOutSdx.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Card.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.CookieOptOut.js';
import 'etc/designs/base/clientlibs/shared/js/modules/Tc.Module.DeviceSwitch.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.DynamicSupport.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.DmisDlc.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.EloquaLP.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.EndlessScrollList.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.ExpandableContainer.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Glossary.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.GridLayout.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.GhqPressReleaseSearch.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.HoverContainer.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.ImageMapContainer.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.ImageMapItem.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.ImagesSlider.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.InfoTeaserContainer.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.LazyContainer.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.LoadingBar.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.LoadingIndicator.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.MultiDropdown.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.MultiDropdownFilterList.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.NewsTicker.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PageBackground.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PersonalizationContainer.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexArticleList.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexCustomerList.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexDocumentList.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexMyStatus.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexFavoriteList.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PriceOrderContainer.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.ProductOfferPreviews.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PromoBadge.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.PromoLabel.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.RatingForm.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.RatingStars.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Richtext.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.RoamingTariff.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.Scene7.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Scene7Stage.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.ScFormArchive.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.ScNewsletter.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.SmoToken.js';
import 'etc/designs/base/clientlibs/shared/js/modules/Tc.Module.SocialShare.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.StageCarousel.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.SupportAgentStatus.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TableSorter.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TableSorter.DirectOrderFilter.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TabNavigation.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TabNavigation.DeprecatedTabs.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TabNavigationContent.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TabNavigationSharedContent.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Tabs.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Tabs.StaticallyLinkedTabs.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TileOrderStatus.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.Timeline.js';
import 'etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.UserFeedback.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Wireline.js';
import 'etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.DownloadPDF.js';

// A-Z please
import 'etc/designs/portal/clientlibs/desktop/js/modules/newrepair/Tc.Module.CaseSelection.js';


// Modern modules (using imports/exports)
import Button from 'lib/sdx/Tc.Module.Button';
import COSMOSResultContainer from 'lib/cosmos/Tc.Module.COSMOSResultContainer';
import CallFromNet from 'lib/contact/Tc.Module.CallFromNet';
import CallOut from 'lib/sdx/Tc.Module.CallOut';
import DataContainer from 'lib/form/Tc.Module.DataContainer';
import DownloadNRepPDF from 'lib/newrepair/Tc.Module.DownloadNRepPDF';
import EasyPointQrCode from 'lib/widget/Tc.Module.EasyPointQrCode';
import EnlargeImageView from 'lib/img/Tc.Module.EnlargeImageView';
import ExpandAndCollapse from 'lib/expandandcollapse/Tc.Module.ExpandAndCollapse';
import FormDataRestore from 'lib/form/Tc.Module.FormDataRestore';
import GcrNewsArchiveResults from 'lib/sdx/gcr-pressrelease/Tc.Module.GcrNewsArchiveResults';
import GcrNewsArchiveSearch from 'lib/sdx/gcr-pressrelease/Tc.Module.GcrNewsArchiveSearch';
import GenericPDFFiller from 'lib/pdf/Tc.Module.GenericPDFFiller';
import GenesysChatForContact from 'lib/contact/Tc.Module.GenesysChatForContact';
import LeadManagement from 'lib/generic/leadmanagement/Tc.Module.LeadManagement';
import LegoContainer from 'lib/ecommerce/lego/Tc.Module.LegoContainer';
import * as legoContainerSkins from 'lib/ecommerce/lego/skins';
import LegoOrderButton from 'lib/ecommerce/lego/Tc.Module.LegoOrderButton';
import LivePersonChatForContact from 'lib/contact/Tc.Module.LivePersonChatForContact';
import LottieAnimatedSVG from 'lib/lottie/Tc.Module.LottieAnimatedSVG';
import OrderOverlay from 'lib/ecommerce/Tc.Module.OrderOverlay';
import OrderOverlayOrderButtons from 'lib/ecommerce/Tc.Module.OrderOverlayOrderButtons';
import PDFQrCode from 'lib/pdf/Tc.Module.PDFQrCode';
import PexArticleDetail from 'lib/pex/Tc.Module.PexArticleDetail';
import PexIncidentInfoDialog from 'lib/pex/Tc.Module.PexIncidentInfoDialog';
import PexIncidentList from 'lib/pex/Tc.Module.PexIncidentList';
import PexMustReadModal from 'lib/pex/Tc.Module.PexMustReadModal';
import PortalStage from 'lib/stage/Tc.Module.PortalStage';
import PriceBox from 'lib/ecommerce/Tc.Module.PriceBox';
import PriceDetails from 'lib/ecommerce/Tc.Module.PriceDetails';
import RatingList from 'lib/ecommerce/Tc.Module.RatingList';
import RatingOverview from 'lib/ecommerce/Tc.Module.RatingOverview';
import RetentionResult from 'lib/ecommerce/Tc.Module.RetentionResult';
import ScrollElement from 'lib/scrollElement/Tc.Module.ScrollElement';
import SDXContactWizard from 'lib/contact/Tc.Module.SDXContactWizard';
import SDXDatePicker from 'lib/sdx/Tc.Module.SDXDatePicker';
import SMSAndChat from 'lib/contact/Tc.Module.SMSAndChat';
import SamAGB from 'lib/personalization/Tc.Module.SamAGB';
import ScrollingArrow from 'lib/sdx/Tc.Module.ScrollingArrow';
import SearchInput from 'lib/search/TC.Module.SearchInput';
import SectionAnchorStage from 'lib/sdx/Tc.Module.SectionAnchorStage';
import ServiceAvailability from 'lib/ecommerce/Tc.Module.ServiceAvailability';
import TemplatingContainer from 'lib/personalization/templating/Tc.Module.TemplatingContainer';
import URLChecker from 'lib/cleanpipe/Tc.Module.URLChecker';
import UserBox from 'lib/personalization/Tc.Module.UserBox';
import WBCOrderButton from 'lib/ecommerce/lego/Tc.Module.WBCOrderButton';

// Tc Bootstrap
import { legacyBootstrapDeferredSingleton } from 'bootstrap/load-terrific';

const modernTcModules = {
	Button,
	COSMOSResultContainer,
	CallFromNet,
	CallOut,
	DataContainer,
	DownloadNRepPDF,
	EasyPointQrCode,
	EnlargeImageView,
	ExpandAndCollapse,
	FormDataRestore,
	GcrNewsArchiveResults,
	GcrNewsArchiveSearch,
	GenericPDFFiller,
	GenesysChatForContact,
	LeadManagement,
	LegoContainer: {
		module: LegoContainer,
		skins: legoContainerSkins,
	},
	LegoOrderButton,
	LivePersonChatForContact,
	LottieAnimatedSVG,
	OrderOverlay,
	OrderOverlayOrderButtons,
	PDFQrCode,
	PexArticleDetail,
	PexIncidentInfoDialog,
	PexIncidentList,
	PexMustReadModal,
	PortalStage,
	PriceBox,
	PriceDetails,
	RatingList,
	RatingOverview,
	RetentionResult,
	SDXContactWizard,
	SDXDatePicker,
	SMSAndChat,
	SamAGB,
	ScrollElement,
	ScrollingArrow,
	SearchInput,
	SectionAnchorStage,
	ServiceAvailability,
	TemplatingContainer,
	URLChecker,
	UserBox,
	WBCOrderButton,
};
legacyBootstrapDeferredSingleton(modernTcModules);



// WEBPACK FOOTER //
// typescript://../clientlibs/js/by-category/scs.portal.desktop.ts